<div class="teasercards teaser" *ngIf="data">
    <header class="teasercardheader" *ngIf="data.headline || data.copytext">
        <h2 *ngIf="data.headline" [innerHTML]="data.headline | superscripe"></h2>
        <p class="large" *ngIf="data.copytext && data.copytext.value" [innerHTML]="data.copytext.value | superscripe"></p>
    </header>
    <div class="cards {{ data._options.cardcolor }} {{ columnClasses }}" *ngIf="itemList.length > 0">
        <div class="card" *ngFor="let card of itemList; let i = index">
            <div class="cardcontent">
                <div class="cardheader">
                    <div class="media" *ngIf="card.image.imageUrl">
                        <figure #image>
                            <da-progressive-image
                                (loaded)="imgLoaded(i)"
                                [options]="{
                                    alt: card.image.altText || card.headline,
                                    aspectRatios: [
                                        {
                                            breakpoint: 360,
                                            width: 480,
                                            height: 320,
                                            akamaiImage: card.image.imageUrl
                                        },
                                        {
                                            breakpoint: 480,
                                            width: 780,
                                            height: 520,
                                            akamaiImage: card.image.imageUrl
                                        },
                                        {
                                            breakpoint: 768,
                                            width: 480,
                                            height: 320,
                                            akamaiImage: card.image.imageUrl
                                        },
                                        {
                                            breakpoint: 960,
                                            width: 380,
                                            height: 253,
                                            akamaiImage: card.image.imageUrl
                                        },
                                        {
                                            breakpoint: 1120,
                                            width: 480,
                                            height: 320,
                                            akamaiImage: card.image.imageUrl
                                        }
                                    ]
                                }"
                            ></da-progressive-image>
                        </figure>
                    </div>
                    <div class="copy" [class.noimg]="!card.image.imageUrl">
                        <h4 *ngIf="card.headline" [innerHTML]="card.headline | superscripe"></h4>
                        <div *ngIf="card.copytext && card.copytext.value" [outerHTML]="card.copytext.value | superscripe"></div>
                    </div>
                </div>
                <div class="cardfooter">
                    <p class="marginless" *ngIf="card.button.url.imageUrl">
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
